import React from "react";
import clsx from "clsx";

import LoadingSpinner from "../../common/LoadingSpinner/LoadingSpinner";
import * as GlobalSelectors from "../../../store/Global/Global.selector";
import Text from "../../common/Text/Text";
import { StoreState } from "../../../store/RootReducer";
import { useSelector } from "../../../lib/hook/ReduxHooks";

interface SpinnerOverlayProps {
	opaque?: boolean;
}

const SpinnerOverlay: React.FC<SpinnerOverlayProps> = ({ opaque }) => {
	const { message, visible } = useSelector((state: StoreState) =>
		GlobalSelectors.getLoadingOverlay(state),
	);

	return (
		<div
			className={clsx("SpinnerOverlay --pdf-ignore", {
				"--visible": visible,
				"--opaque": opaque,
			})}
		>
			<div className={"SpinnerOverlay__container"}>
				<LoadingSpinner visible={visible} />
				<br />
				<Text
					tag={"p"}
					className={clsx("SpinnerOverlay__message", visible && "--visible")}
				>
					{message}
				</Text>
			</div>
		</div>
	);
};

export default React.memo(SpinnerOverlay);
